// extracted by mini-css-extract-plugin
export default {"associations":"LocatedEntityAssociation_associations__nHDUU"};